import { Button, ClickEvent, DataSourceExecutionEvent, DataSourceMode, DataSourceModeChangeEvent, DataSourceValidationEvent, LayoutProps, LookupModelSearchEvent, Snackbar } from "@mcleod/components";
import { AutogenLayoutSmc3Control } from "./autogen/AutogenLayoutSmc3Control";
import { CommonDialogs } from "@mcleod/common";
import { Api } from "@mcleod/core";

interface Smc3ControlLayoutProps extends LayoutProps {
    vendorId: string;
}

export class Smc3Control extends AutogenLayoutSmc3Control {

    constructor(props?: Partial<Smc3ControlLayoutProps>) {
        super(props);
    }

    async onLoad() {
        this.buttonTestConnection.doOnDataSourceChanged = (ds, value) => {  this.buttonTestConnection.enabled = !value; }
        this.mainDataSource.addHasChangedComponent(this.buttonTestConnection);

        this.buttonInitiateTracking.doOnDataSourceChanged = (ds, value) => { this.buttonInitiateTracking.enabled = !value; }
        this.mainDataSource.addHasChangedComponent(this.buttonInitiateTracking);

        this.buttonDeactivateTracking.doOnDataSourceChanged = (ds, value) => { this.buttonDeactivateTracking.enabled = !value; }
        this.mainDataSource.addHasChangedComponent(this.buttonDeactivateTracking);

        this.buttonCreateCompany.doOnDataSourceChanged = (ds, value) => { this.buttonCreateCompany.enabled = !value; }
        this.mainDataSource.addHasChangedComponent(this.buttonCreateCompany);

        this.buttonTestConnection.disabledTooltip = "You cannot Test Connection because something has changed or service not Active";
        this.buttonInitiateTracking.disabledTooltip = "You cannot Initiate Tracking because something has changed or service not Active";
        this.buttonDeactivateTracking.disabledTooltip = "You cannot Deactivate Tracking because something has changed or service not Active";
        this.buttonCreateCompany.disabledTooltip = "You cannot Create Company because something has changed or service not Active";
    }

    async postDataSources(vendorId: string): Promise<boolean> {
        try {
            this.mainDataSource?.activeRow?.set("id", vendorId);
            await this.mainDataSource.post();
            return true;
        } catch (error) {
            return false;
        }
    }

    sourceContractManagementControlAfterExecution(event: DataSourceExecutionEvent) {
        this.buttonTestConnection.enabled = this.checkboxActive.checked;
        this.buttonInitiateTracking.enabled = this.checkboxActive.checked;
        this.buttonDeactivateTracking.enabled = this.checkboxActive.checked;
        this.buttonCreateCompany.enabled = this.checkboxActive.checked;
    }

    async buttonCreateCompanyOnClick(event: ClickEvent) {
        const createButton: Button = event.target as Button;
        CommonDialogs.showInputDialog("Company Name", "Create SMC3 Company", {
            required: true
        }).then(async (companyName) => {
            if (companyName != null) {
                createButton.busy = true;
                Api.post("lme/powerbroker/smc3-api-control", { action: "create-company", company_name: companyName }).then(result => {
                    createButton.busy = false;
                    if (result) {
                        const status: string = result?.data[0]?.status;
                        const message: string = result?.data[0]?.message;
                        if (status == "PASS" || status == "EXISTS") {
                            this.mainDataSource.search({ vendor: "SLA" }).then(response => {
                                Snackbar.showSnackbar(message);
                            });
                        } else
                            Snackbar.showSnackbar(message);
                    }
                });
            }
        });
    }

    buttonTestConnectionOnClick(event: ClickEvent) {
        const createButton: Button = event.target as Button;
        createButton.busy = true;
        Api.post("lme/powerbroker/smc3-api-control", { action: "test-connection" }).then(result => {
            createButton.busy = false;
            if (result) {
                const message: string = result?.data[0]?.message;
                Snackbar.showSnackbar(message);
            }
        });
    }

    buttonInitiateTrackingOnClick(event: ClickEvent) {
        const createButton: Button = event.target as Button;
        createButton.busy = true;
        Api.post("lme/powerbroker/smc3-api-control", { action: "initiate-tracking" }).then(result => {
            createButton.busy = false;
            if (result) {
                const message: string = result?.data[0]?.message;
                Snackbar.showSnackbar(message, {customMaxWidth: 725, persist: true});
            }
        });
    }

    buttonDeactivateTrackingOnClick(event: ClickEvent) {
        const createButton: Button = event.target as Button;
        createButton.busy = true;
        Api.post("lme/powerbroker/smc3-api-control", { action: "deactivate-tracking" }).then(result => {
            createButton.busy = false;
            if (result) {
                const message: string = result?.data[0]?.message;
                Snackbar.showSnackbar(message);
            }
        });
    }

    textboxSmc3ProfileIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.config_type = "N";
    }
}
